import { Color } from '@signaturit/react-components-library';
import { WheelColor } from '../Gauges/WheelContainer/WheelColor.enum';
import { LicenseCodename } from '../../constants/LicenseCodename';
import { User } from '../../../models/User';

export const MANAGE_CREDITS_BUTTON_COLOR_DEFAULT = Color.secondary;

type ColorMap = {
    [K in WheelColor]: Color.secondary | Color.warning | Color.error;
};

export const getColorMap = (
    colorLabel: WheelColor
): Color.primary | Color.secondary | Color.tertiary | Color.warning | Color.error => {
    const colorMap = {
        [WheelColor.full]: Color.secondary,
        [WheelColor.semiEmpty]: Color.warning,
        [WheelColor.empty]: Color.error,
    } as ColorMap;

    const mappedColor = colorMap[colorLabel];
    return mappedColor ? mappedColor : MANAGE_CREDITS_BUTTON_COLOR_DEFAULT;
};

export const canShowOfflinePaymentButton = (userInfo?: User): boolean => {
    const offlinePayment = !!userInfo?.adHoc;
    const isEnterprise = userInfo?.codename === LicenseCodename.enterprise;

    if (isEnterprise) {
        return true;
    }
    return offlinePayment;
};
